import { Flex, Text } from '@chakra-ui/react';
import getFormattedAmount from 'helpers/getFormattedAmount';
import React from 'react';

interface WorkshopPriceProps {
  price: number;
  currency: string;
}

const WorkshopPrice = ({ price, currency }: WorkshopPriceProps) => {
  return (
    <Flex alignItems="baseline">
      <Text
        fontSize="18px"
        lineHeight="23px"
        fontWeight={[500, 500, 700]}
        color="var(--neutral-700)"
        marginRight="5px"
      >
        {getFormattedAmount({
          amount: price,
          currency
        })}
      </Text>
      <Text
        fontSize="14px"
        lineHeight="23px"
        fontWeight={[500, 500, 700]}
        color="var(--neutral-700)"
      >
        {currency ?? ''}
      </Text>
    </Flex>
  );
};

export default WorkshopPrice;
